import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'

import { ENTITY_TAB_POSTS_FILTER_SUB_MENU } from './EntityTabPosts.constants'

export function getEntityTabPostsFilterBarPermanentFilters() {
  return { [FILTER_NAME_SUB_MENU]: ENTITY_TAB_POSTS_FILTER_SUB_MENU }
}

export function parseEntityTabPostsFilterBarPermanentFilters(filters) {
  return [[FILTER_NAME_SUB_MENU, filters[FILTER_NAME_SUB_MENU]]]
}
